export default "__VITE_ASSET__CCx1osw1__"